import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminProduct from './AdminProduct';

export default withRequiredAdmin(AdminProduct);
